import { Component } from '@angular/core';
import { AgFilterComponent } from "ag-grid-angular";
import { IDoesFilterPassParams, IFilterParams } from "ag-grid-community";
import { UniversityPerson } from '../models';

@Component({
    selector: 'university-person-filter-component',
    template: `
        <div class="p-3" style="max-width: 300px;">
            <university-person [(ngModel)]="universityPerson" (ngModelChange)="onUniversityPersonChange($event)"></university-person>
        </div>
   `
})
export class UniversityPersonFilter implements AgFilterComponent {
    params: IFilterParams;
    universityPerson: UniversityPerson;

    constructor() {

    }

    agInit(params: IFilterParams): void {
        this.params = params;
    }

    isFilterActive(): boolean {
        return true;
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        if (!this.universityPerson) return true;
        return params.data.contact.univId === this.universityPerson.univId;
    }

    getModel() {
    }

    setModel(model: any) {
    }

    onUniversityPersonChange(universityPerson: UniversityPerson) {
        this.params.filterChangedCallback();
    }
}